// removed by extract-text-webpack-plugin
module.exports = {"header-area":"header-area__2262A","ie-flexbox-fix":"ie-flexbox-fix__3DIEY","registration-area":"registration-area__N316Z","header-row":"header-row__3-Xdy","active-raffles":"active-raffles__3q-Z5","divider":"divider__5xYWn"};


//////////////////
// WEBPACK FOOTER
// ./routes/raffle/styles/RaffleDetail.scss
// module id = EWu5
// module chunks = 1